import React from 'react';
import {
    BarChart as RechartsBarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    LabelList,
    Legend,
} from 'recharts';
import { COLORS } from '../../constants';
import { CHART_DIMENSIONS, TEXT_STYLES, ANIMATION_CONFIG } from './styles';

export const BarChartComponent = ({ 
    data, 
    legend, 
    dimensions, 
    yAxisWidth, 
    theme, 
    renderYAxisTick, 
    CustomTooltip,
    colorIndices,
    className,
    style
}) => {
    return (
        <ResponsiveContainer width="100%" height={dimensions.height} className={className} style={style}>
            <RechartsBarChart
                data={data}
                layout="vertical"
                margin={{
                    top: CHART_DIMENSIONS.MARGIN.TOP,
                    right: CHART_DIMENSIONS.MARGIN.RIGHT,
                    left: yAxisWidth + CHART_DIMENSIONS.MARGIN.LEFT_OFFSET,
                    bottom: CHART_DIMENSIONS.MARGIN.BOTTOM,
                }}
                barSize={dimensions.barSize}
                animationDuration={ANIMATION_CONFIG.DURATION}
                animationEasing={ANIMATION_CONFIG.EASING}
            >
                <CartesianGrid 
                    strokeDasharray="3 3" 
                    stroke={theme.palette.grey[200]}
                    horizontal={false}
                />
                <XAxis
                    type="number"
                    domain={[0, 100]}
                    allowDataOverflow={true}
                    tickFormatter={(value) => `${Number.isInteger(value) ? value : value.toFixed(1)}%`}
                    tick={{
                        ...TEXT_STYLES.AXIS_TICK,
                        fontFamily: theme.typography.fontFamily,
                        fill: theme.palette.text.primary,
                    }}
                />
                <YAxis
                    dataKey="text"
                    type="category"
                    width={yAxisWidth}
                    tick={renderYAxisTick}
                />
                <Tooltip 
                    content={<CustomTooltip />}
                    cursor={{ fill: 'rgba(0,0,0,0.05)' }}
                    animationDuration={ANIMATION_CONFIG.DURATION}
                />
                <Legend
                    verticalAlign="top"
                    align="right"
                    iconSize={TEXT_STYLES.LEGEND.iconSize}
                    iconType="square"
                    wrapperStyle={{
                        ...TEXT_STYLES.LEGEND
                    }}
                    itemMarginRight={100}
                />
                {legend.map((item, index) => (
                    <Bar
                        key={item.name}
                        dataKey={`ats[${index}].val`}
                        name={item.name}
                        fill={COLORS[item.originalIndex % COLORS.length]}
                        stackId="stack"
                        radius={[0, 4, 4, 0]}
                        animationDuration={ANIMATION_CONFIG.DURATION}
                        animationEasing={ANIMATION_CONFIG.EASING}
                    >
                        <LabelList
                            dataKey={`ats[${index}].val`}
                            position="center"
                            content={({ x, y, width, height, value }) => {
                                if (value > 10) {
                                    return (
                                        <text
                                            x={x + width / 2}
                                            y={y + height / 2}
                                            fill="#fff"
                                            textAnchor="middle"
                                            dominantBaseline="central"
                                            style={{
                                                ...TEXT_STYLES.PERCENTAGE_LABEL,
                                                fontFamily: theme.typography.fontFamily,
                                            }}
                                        >
                                            {`${Number.isInteger(value) ? value : value?.toFixed(1)}%`}
                                        </text>
                                    );
                                }
                                return null;
                            }}
                        />
                    </Bar>
                ))}
            </RechartsBarChart>
        </ResponsiveContainer>
    );
};
